import { render, staticRenderFns } from "./ScrollContainer.vue?vue&type=template&id=7bfc876b&scoped=true"
import script from "./ScrollContainer.vue?vue&type=script&lang=ts"
export * from "./ScrollContainer.vue?vue&type=script&lang=ts"
import style0 from "./ScrollContainer.vue?vue&type=style&index=0&id=7bfc876b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfc876b",
  null
  
)

export default component.exports